import { isEmpty } from './is-empty';

/**
 * Checks whether the provided value is not considered "empty".
 *
 * - Returns `true` if the value is not empty according to the rules defined in `isEmpty`.
 * - Returns `false` if the value is empty.
 *
 * @typeParam T - The type of the value to check.
 * @param value - The value to check for non-emptiness.
 * @returns `true` if the value is not empty, otherwise `false`.
 */
export const isNotEmpty = <T = unknown>(value: T | null | undefined): boolean => {
  return !isEmpty(value);
};
